import { useEffect, useRef } from "react";

const useSecurity = () => {
    const redirected = useRef(false);
    

    useEffect(() => {
        const applyBlur = (shouldBlur) => {
           
            if (shouldBlur) {
                document.body.style.filter = "blur(20px) grayscale(100%)";
                document.body.style.pointerEvents = "none";
                document.body.style.userSelect = "none";
            } else {
                document.body.style.filter = "none";
                document.body.style.pointerEvents = "auto";
                document.body.style.userSelect = "auto";
            }
        }; 

        const redirect = () => {
            applyBlur(true);
            if (!redirected.current) {
                redirected.current = true;
                window.location.replace("https://google.com");
            }
        };


        const startDebuggerLoop = () => {
            (function a() {
                try {
                    (function b(i) {
                        if (('' + (i / i)).length !== 1 || i % 20 === 0) {
                            (function () { }).constructor('debugger')();
                        } else {
                            debugger;
                        }

                        const start = performance.now();
                        b(++i);
                        const end = performance.now();

                        if (end - start > 100) redirect();
                    })(0);
                } catch (e) {
                    setTimeout(a, 1000);
                }
            })();
        };

        const detectSize = () => {
            const threshold = 160;
            if (
                window.outerWidth - window.innerWidth > threshold ||
                window.outerHeight - window.innerHeight > threshold
            ) {
                redirect();
            }
        };

        const detectConsole = () => {
            const element = new Image();
            Object.defineProperty(element, "id", {
                get() { redirect(); }
            });
            console.log(element);
        };


        startDebuggerLoop();

        const interval = setInterval(() => {
            detectSize();
            detectConsole();
        }, 500);


        const blockKeys = (e) => {
            const ctrl = e.ctrlKey || e.metaKey;
            if (
                e.key === "F12" ||
                (ctrl && e.shiftKey && ["I", "J", "C"].includes(e.key.toUpperCase())) ||
                (ctrl && e.key.toLowerCase() === "u")
            ) {
                e.preventDefault();
                redirect();
            }
        };

        document.addEventListener("keydown", blockKeys);
        document.addEventListener("contextmenu", (e) => e.preventDefault());
        window.addEventListener("resize", detectSize);

        return () => {
            clearInterval(interval);
            document.removeEventListener("keydown", blockKeys);
            window.removeEventListener("resize", detectSize);
        };
    }, []);
};

export default useSecurity;